<script setup>
// Centered "nothing here yet" block for lists and feeds; an optional
// action (e.g. an Add button) goes in the default slot.
defineProps({
  icon: { type: String, default: 'mdi-tray' },
  title: { type: String, required: true },
  description: { type: String, default: '' },
});
</script>

<template>
  <div class="ui-empty">
    <span class="ui-empty__icon"><v-icon size="20">{{ icon }}</v-icon></span>
    <p class="ui-empty__title">{{ title }}</p>
    <p v-if="description" class="ui-empty__description">{{ description }}</p>
    <div v-if="$slots.default" class="ui-empty__action"><slot /></div>
  </div>
</template>

<style scoped>
.ui-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 40px 24px;
  border: 1px dashed var(--border-strong);
  border-radius: 12px;
  text-align: center;
}
.ui-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 6px;
  border-radius: 10px;
  background-color: var(--accent);
  color: var(--muted-foreground);
}
.ui-empty__title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}
.ui-empty__description {
  margin: 0;
  max-width: 360px;
  font-size: 14px;
  color: var(--muted-foreground);
}
.ui-empty__action {
  margin-top: 10px;
}
</style>
